export const TextConfig = {

	"brandName": "TurboSteed",

	"heroTitle": "Build client sites with Claude Code. Host them on TurboSteed.",
	"heroDescription": "Connect Claude Code via MCP, use the TurboSteed Skill, and deploy static sites in seconds. No infrastructure headaches.",

	"mcpConfig": {
		"headline": "Add to your .mcp.json config:",
		"snippet": `{
  "mcpServers": {
    "turbosteed": {
      "command": "turbosteed",
      "args": ["--mcp"],
      "env": {
        "TURBOSTEED_ACCOUNT_SID": "your_account_sid",
        "TURBOSTEED_API_KEY": "your_api_key",
        "TURBOSTEED_SITE_ID": "your_site_id"
      }
    }
  }
}`
	},

	"personas": [
		{
			"usecase": "Claude Code + MCP",
			"persona": "Build sites using Claude Code with TurboSteed's MCP server integration",
			"icon": "fa fa-magic"

		},
		{
			"usecase": "Upload Your Code",
			"persona": "Deploy your own HTML/CSS/JS via CLI, API, or zip upload",
			"icon": "fa fa-code"

		}
	],

	"howItWorks": [
		{
			"step": 1,
			"title": "Create Account",
			"description": "Sign up on TurboSteed dashboard and get your API credentials."
		},
		{
			"step": 2,
			"title": "Configure MCP",
			"description": "Add the MCP config to your Claude Code environment."
		},
		{
			"step": 3,
			"title": "Install Skill",
			"description": "Install the TurboSteed Skill file for guided site creation."
		},
		{
			"step": 4,
			"title": "Build & Deploy",
			"description": "Describe your requirements. Claude Code builds and deploys."
		}
	],

	"benefits": [
		{
			"feature": "MCP Integration",
			"value": "Connect Claude Code via MCP for full site control — pages, content, assets, and deployments.",
			"icon": "icon-layers",
			"aria-label": "MCP integration for AI-driven site management",
			"readmeUrl": "https://turbosteed.freshdesk.com/support/home"
		},
		{
			"feature": "Headless CMS",
			"value": "Define schemas, manage entries via API. Perfect for dynamic content workflows.",
			"icon": "icon-documents",
			"aria-label": "Headless CMS for content management",
			"readmeUrl": "/features/cms"
		},
		{
			"feature": "CLI Deployment",
			"value": "Install @turbosteed/cli via npm. Deploy with one command or integrate into CI/CD.",
			"icon": "icon-tools",
			"aria-label": "CLI deployment tools",
			"readmeUrl": "https://www.npmjs.com/package/@turbosteed/cli"
		},
		{
			"feature": "REST API",
			"value": "Full API access for site configuration, content management, and asset uploads.",
			"icon": "icon-gears",
			"aria-label": "REST API access",
			"readmeUrl": "/docs/rest-api.html"
		},
		{
			"feature": "Global CDN",
			"value": "Every site is served via global CDN for fast delivery worldwide.",
			"icon": "icon-speedometer",
			"aria-label": "Global CDN delivery",
			"readmeUrl": "https://turbosteed.freshdesk.com/support/solutions/articles/1120000042671-turbosteed-platform-features#CDN"
		},
		{
			"feature": "No Lock-in",
			"value": "Use any framework or plain HTML/CSS/JS. Export your code anytime.",
			"icon": "icon-browser",
			"aria-label": "No vendor lock-in",
			"readmeUrl": "https://turbosteed.freshdesk.com/support/solutions/articles/1120000042671-turbosteed-platform-features#No-Platform-Lock-in-for-custom-sites"
		}
	],

	"cliInstall": {
		"command": "npm install -g @turbosteed/cli",
		"npmUrl": "https://www.npmjs.com/package/@turbosteed/cli"
	},

	"secondaryValueProp": "Scale without worry",
	"secondaryValuePropDescription": "TurboSteed provides a hassle-free, scalable platform so you can focus on building for your clients."
};

export const BrandName = "TurboSteed";
